import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SalesReportRequest } from '../models/common-data-types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private http: HttpClient) { }

  generateReport(payload: SalesReportRequest): Observable<any>{
    return this.http.post('/admin/reports/sales',payload);
  }
}
